<template>
  <div class="view candidates">
    <h1>Kandidaten</h1>
    <div class="pages">
      <router-link to="/candidates/jobs" class="page jobs">
        <div class="page-title">Find jobs</div>
        <div class="page-subtitle">Aktuelle <br>HR-Vakanzen</div>
      </router-link>
      <router-link to="/candidates/faq" class="page faq">
        <div class="page-title">FAQ</div>
        <div class="page-subtitle">Häufige Fragen</div>
      </router-link>
      <router-link to="/candidates/process" class="page process">
        <div class="page-title">Unzer prozess</div>
        <div class="page-subtitle">Wie funktioniert<br>die Zusammenarbeit?</div>
      </router-link>
      <router-link v-if="user" to="/profile" class="page login">
        <div class="page-title">Profile</div>
        <div class="page-subtitle">Ihr Profil</div>
      </router-link>
      <router-link v-else to="/login" class="page login">
        <div class="page-title">Login</div>
        <div class="page-subtitle">Ihr Profil</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'candidates',
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
  }
}
</script>

<style scoped>
.candidates {
  padding-top: 26.85vh;
  text-align: center;
}

.candidates h1 {
  font: 400 6.66vh/1 'Exodus Demo St';
  color: #ffd675;
  margin: 0;
}

.candidates h1:after {
  content: '';
  display: block;
  width: 32.6vh;
  height: 8px;
  background: url(../assets/tr_o_title-line.svg) no-repeat center/contain;
  margin: 3.88vh auto 0;
}

.pages {
  display: flex;
  justify-content: center;
  margin-top: 11.11vh;
}

.pages .page {
  width: 35.93vh;
  height: 25vh;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: auto 100%;
  text-align: left;
  padding-left: 12vh;
  padding-top: 9.7vh;
  margin: 0 1vw;
}

.pages .page.jobs {
  background-image: url(../assets/tr_ic_jobs.svg);
}

.pages .page.faq {
  background-image: url(../assets/tr_ic_faq.svg);
}

.pages .page.process {
  background-image: url(../assets/tr_ic_process.svg);
}

.pages .page.login {
  background-size: 14.5vw auto;
  background-image: url(../assets/tr_ic_login.svg);
  padding-left: 15.4vh;
  height: 22vh;
  background-size: contain;
}

.pages .page .page-title {
  font: 400 2.87vh/1 'Exodus Demo St';
  margin-bottom: 1.12vh;
}

.pages .page .page-subtitle {
  color: #fff;
  font-size: 1.11vh;
  letter-spacing: .4em;
}

@media screen and (max-width: 1024px) {
  .candidates {
    padding: 0;
  }
  .candidates h1 {
    font-size: 34px;
  }
  .candidates h1:before {
    content: '';
    display: block;
    width: 102px;
    height: 104px;
    margin: 0 auto 12px;
    background: url(../assets/tr_m_ic_candidates.svg) no-repeat center/contain;
  }
  .candidates h1:after {
    margin-top: 12px;
  }
  .pages {
    flex-flow: column nowrap;
    margin: 0 0 80px;
  }
  .pages .page {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: auto;
    height: 244px;
    background-size: contain;
    background-position: center;
    padding: 0;
    margin: 80px 0 0;
  }
  .pages .page .page-title {
    font-size: 31px;
    margin: 0 0 8px;
  }
  .pages .page .page-subtitle {
    font-size: 12px;
  }
}
</style>
